import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { StaffDTO } from '@core/apis/staff/staff.dto';
import { CopyComponent } from '@core/components/copy/copy.component';
import { FullNamePipe } from '@core/pipes/full-name.pipe';
import { SignedUrlPipe } from '@core/pipes/signed-url.pipe';
import { StaffStore } from '@core/stores/staff.store';
import { TranslocoModule } from '@jsverse/transloco';
import { UntilDestroy } from '@ngneat/until-destroy';
import { SolvaigInstructionComponent } from './solvaig-instruction/solvaig-instruction.component';

@Component({
  selector: 'app-patient-info',
  imports: [CommonModule, TranslocoModule, FullNamePipe, SignedUrlPipe, CopyComponent, SolvaigInstructionComponent],
  standalone: true,
  templateUrl: './staff-info.component.html',
  styleUrl: './staff-info.component.scss',
})
@UntilDestroy()
export class StaffInfoComponent {
  public staff: StaffDTO | null = null;
  public awsPath: string = '';

  constructor(private readonly staffStore: StaffStore) {}

  ngOnInit(): void {
    this.getStaff();
  }

  private getStaff(): void {
    this.staff = this.staffStore.get();
    if (!this.staff) return;
    this.awsPath = `${'users/' + this.staff.user.id + '/avatar'}`;
  }
}
